const requestAccessPath = '/auth/register';
export default requestAccessPath;
